import React, { useLayoutEffect } from 'react';
import Step2 from '../Components/Step2/Step2';
import { StepNavigationHeader } from '../Shared/Widgets/StepsNavigationHeader/StepsNavigationHeader';
import Breadcrumbs from '@shared/Widgets/Navigation/Breadcrumbs/Breadcrumbs';
import { BREADCRUMBS_LABELS } from '@configs/BreadcrumbsLabels';
import { useParams } from 'react-router-dom';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { SESSION_STORAGE_KEYS } from '@configs/SessionStorageKeys';

const Step2Page: React.FC = () => {
    const shouldReload = sessionStorage.getItem(
        SESSION_STORAGE_KEYS.SHOULD_RELOAD_STEP2_PAGE
    );

    useLayoutEffect(() => {
        if (shouldReload) {
            window.location.reload();
            sessionStorage.removeItem(
                SESSION_STORAGE_KEYS.SHOULD_RELOAD_STEP2_PAGE
            );
        }
    }, [shouldReload]);

    if (shouldReload) {
        return null;
    }

    const [isDesktop] = useMediaType();

    return (
        <>
            {isDesktop && (
                <Breadcrumbs items={BREADCRUMBS_LABELS.CREATE_NEW_PROJECT} />
            )}
            <StepNavigationHeader />
            <Step2 />
        </>
    );
};

export default Step2Page;
